module.exports = __webpack_public_path__ + "static/media/offer-img.a8021c77.svg";